import React, {useContext} from "react";
import "./Services.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import {motion} from "framer-motion";
import Resume from './resume.pdf';
import {themeContext} from "../../Context";

const Services = () => {
    // context
    const theme = useContext(themeContext);
    const darkMode = theme?.state.darkMode;

    // transition
    const transition = {
        duration: 1,
        type: "spring",
    };

    return (
        <div className="services" id="services">
            {/* left side */}
            <div className="awesome">
                {/* dark mode */}
                <span style={{color: darkMode ? "white" : ""}}>My Awesome</span>
                <span>services</span>
                <span>
         I have the ability to design visually appealing websites
                    by utilizing ReactJS and .NET, and <br/>
                    can also ensure high-quality websites
                    using Solidity in Web 3.
        </span>
                <a href={Resume} download>
                    <button className="button s-button">Download CV</button>
                </a>
                <div className="blur s-blur1" style={{background: "#ABF1FF94"}}/>
            </div>
            {/* right */}
            <div className="cards">
                {/* first card */}
                <motion.div
                    initial={{left: "25rem"}}
                    whileInView={{left: "14rem"}}
                    transition={transition}
                >
                    <Card
                        color={"black"}
                        emoji={HeartEmoji}
                        heading={"Frontend"}
                        detail={"Java Script React HMLT CSS Webpack UI components"}
                    />
                </motion.div>
                {/* second card */}
                <motion.div
                    initial={{left: "-11rem", top: "12rem"}}
                    whileInView={{left: "-4rem"}}
                    transition={transition}
                >
                    <Card
                        color={"black"}
                        emoji={Glasses}
                        heading={"Backend"}
                        detail={"Dot net C# Docker AWS"}
                    />
                </motion.div>
                {/* 3rd */}
                <motion.div
                    initial={{top: "19rem", left: "25rem"}}
                    whileInView={{left: "12rem"}}
                    transition={transition}
                >
                    <Card
                        emoji={Humble}
                        heading={"Web3"}
                        detail={
                            "Solidity Truffle"
                        }
                        color="rgba(252, 166, 31, 0.45)"
                    />
                </motion.div>
                <div
                    className="blur s-blur2"
                    style={{background: "var(--purple)"}}
                />
            </div>
        </div>
    );
};

export default Services;
